import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.css',
})
export class ToolbarComponent implements OnInit {
  @Input() backButton = false;
  @Input() transparent = false;
  @Input() iconBackClass = '';
  @Input() wideCenter = false;

  @Output() backPressed = new EventEmitter<void>();

  constructor(private navController: NavController) {}

  ngOnInit(): void {}

  back() {
    if (this.backPressed.observed) {
      this.backPressed.emit();
    } else {
      this.navController.back();
    }
  }
}
